<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/' + props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{
                    'v-breadcrumbs__item v-breadcrumbs__item--disabled':
                      props.item.disabled,
                  }"
                  >{{ props.item.text }}</router-link
                >
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex xs-6 xs6 offset-sm3>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12 v-if="responseError">
                <span class="red--text">* {{ responseError }}</span>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="code"
                  label="Code"
                  v-model="counter.code"
                  type="text"
                  :rules="rules.codeRules"
                >
                </v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="name"
                  label="Name"
                  v-model="counter.name"
                  type="text"
                  :rules="rules.nameRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-autocomplete
                  :items="shopList"
                  v-model="counter.shopId"
                  label="Choose Shop"
                  item-text="name"
                  item-value="id"
                  menu-props="auto"
                  :rules="rules.shopRules"
                  :readonly="user.roleName == 'SALE_MANAGER'"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm12>
                <v-textarea
                  name="description"
                  label="Description"
                  v-model="counter.description"
                  type="text"
                  :rules="rules.descriptionRules"
                ></v-textarea>
              </v-flex>
              <v-flex sm12 v-if="counter.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Created Date"
                    type="text"
                    prepend-icon="event"
                    v-model="createdDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="createdDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="counter.id">
                <v-text-field
                  name="createdBy"
                  label="Created By"
                  v-model="counter.createdBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="counter.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Updated Date"
                    type="text"
                    prepend-icon="event"
                    v-model="updatedDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="updatedDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="counter.id">
                <v-text-field
                  name="updateBy"
                  label="Updated By"
                  v-model="counter.updatedBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="counter.id">
                <v-switch
                  :label="`Status is ${statusFlag ? 'Active' : 'Inactive'}`"
                  :value="statusFlag"
                  v-model="statusFlag"
                ></v-switch>
              </v-flex>
              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn color="error" @click="clear">
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn
                    color="primary"
                    :loading="saveLoading"
                    :disabled="!valid"
                    @click="onSave"
                  >
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
import { counterService } from "../../services/counter-service";
import { commonService } from "../../services/common-service";
import { shopService } from "../../services/shop-service";
import { Counter } from "../../models/model";
import { CounterFormRules } from "../../helpers/validation-rules";

export default {
  name: "CounterDetail",
  components: {},
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    valid: true,
    saveLoading: false,
    breadcrumbs: [
      {
        text: "Counter",
        disabled: false,
        to: "counters",
      },
      {
        text: "Counter Detail",
        disabled: true,
      },
    ],
    counter: new Counter(),
    oldCounter: new Counter(),
    rules: new CounterFormRules(),
    responseError: "",
    createdDate: "",
    updatedDate: "",
    shopList: [],
    statusFlag: true,
  }),
  created() {
    this.getShopList();
    if (this.user.roleName == "SALE_MANAGER") {
      this.counter.shopId = this.user.shopId;
    }

    const id = this.$route.params.id;
    if (id == "new") {
      //new counter
    } else {
      //edit counter
      this.getCounterDetail(id);
    }
  },
  methods: {
    getShopList() {
      shopService
        .getAllShop()
        .then((res) => {
          this.shopList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    goBack() {
      this.$router.push("/counters");
    },
    clear() {
      this.$refs.form.resetValidation();
      if (!this.counter.id) {
        this.counter = new Counter();
        this.statusFlag = true;
        if (this.user.roleName == "SALE_MANAGER") {
          this.counter.shopId = this.user.shopId;
        }
      } else {
        this.counter = Object.assign({}, this.oldCounter);
        this.statusFlag = this.counter.status == "ACTIVE" ? true : false;
      }
    },
    getCounterDetail(id) {
      counterService
        .getCounterDetail(id)
        .then((res) => {
          this.counter = res.data;
          this.createdDate = commonService.millisecondToDate(
            this.counter.createdDateInMilliSeconds,
            "YYYY-MM-DD"
          );
          this.updatedDate = commonService.millisecondToDate(
            this.counter.updatedDateInMilliSeconds,
            "YYYY-MM-DD"
          );
          //deep copy
          this.oldCounter = JSON.parse(JSON.stringify(res.data));
          this.statusFlag = this.counter.status == "ACTIVE" ? true : false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onSave() {
      if (this.$refs.form.validate()) {
        if (!this.saveLoading) {
          this.saveLoading = true;
          this.counter.status = this.statusFlag ? "ACTIVE" : "INACTIVE";
          counterService
            .saveCounter(this.counter)
            .then((res) => {
              console.log(res);
              this.goBack();
            })
            .catch((err) => {
              console.log(err);
              if (err.response.data) {
                this.responseError = err.response.data.message;
              }
            })
            .finally(() => {
              this.saveLoading = false;
            });
        }
      }
    },
  },
};
</script>
